import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { AdresseDestinations } from 'constants.js';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';



import ArticleGestionSearch from 'components/Shared/ArticleGestionSearch';
import MyDatePicker from 'components/Shared/MyDatePicker';


const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    marginTop: {
        marginTop: 10
    },
    
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },

    column: {
        width: '45%'
    },

    cell: {
        padding: '4px 8px 4px 8px'
    }
});

class DemandeEnlevementDialogContent extends React.Component {

    constructor(props) {
        super(props);
        
        let articles = JSON.parse(JSON.stringify(props.articles));
        articles = articles.map((x) => {
            return { ...x, quantiteAEnlever: 0 };
        });

        this.state = {
            adresseEnlevementNomLivraison: this.props.adresse && this.props.adresse.nomLivraison ? this.props.adresse.nomLivraison : '',
            adresseEnlevementAdresse1: this.props.adresse && this.props.adresse.adresse1 ? this.props.adresse.adresse1 : '',
            adresseEnlevementAdresse2: this.props.adresse && this.props.adresse.adresse2 ? this.props.adresse.adresse2 : '',
            adresseEnlevementCodePostal: this.props.adresse && this.props.adresse.codePostal ? this.props.adresse.codePostal : '',
            adresseEnlevementVille: this.props.adresse && this.props.adresse.ville ? this.props.adresse.ville : '',

            contactClientNom: this.props.contact && this.props.contact.nom ? this.props.contact.nom : '',
            contactClientEmail: this.props.contact && this.props.contact.email ? this.props.contact.email : '',
            contactClientTelephone: this.props.contact && this.props.contact.telephone ? this.props.contact.telephone : '',

            dateSouhaitee: null,

            adresseDestinationCode: '',
            adresseDestinationNom: '',
            adresseDestinationAdresse1: '',
            adresseDestinationAdresse2: '',
            adresseDestinationCodePostal: '',
            adresseDestinationVille: '',

            montantDevis: 0,
            factureClient: '0',
            numeroFacture: '',

            articles: articles,
            poidsTheorique: 0,
            nbPalettes: 0,
            nbColis: 0,
            nbLongueurs: 0,

            articleHorsPiece: null,
            codeTR : ''
        };
    }

    componentDidMount() {
        let actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (newState.transporteurId === -1) {
            return null;
        }

        if (!newState.adresseEnlevementNomLivraison
            || !newState.adresseEnlevementAdresse1
            || !newState.adresseEnlevementCodePostal
            || !newState.adresseEnlevementVille
           ) {
            return null;
        }

        if (newState.adresseDestinationCode === '') {
            return null;
        } 

        if (newState.adresseDestinationCode === 3
            && (!newState.adresseDestinationNom
                || !newState.adresseDestinationAdresse1
                || !newState.adresseDestinationCodePostal
                || !newState.adresseDestinationVille)
        ) {
            return null;
        }


        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Adresse,
                type: ReclamationActionDetailType.Texte,
                libelle: `Adresse d'enlèvement`,
                position: 0,
                valeurString: `${newState.adresseEnlevementNomLivraison}\n${newState.adresseEnlevementAdresse1}\n${newState.adresseEnlevementAdresse2}\n${newState.adresseEnlevementCodePostal} ${newState.adresseEnlevementVille}`
            }, {
                code: ReclamationActionDetailCodes.ContactClient,
                type: ReclamationActionDetailType.Texte,
                libelle: `Contact client nécessaire à l'enlèvement`,
                position: 1,
                valeurString: `${newState.contactClientNom} (${newState.contactClientEmail} / ${newState.contactClientTelephone})`
            }]
        };

        if (newState.dateSouhaitee !== null)
        {
            actionData.details.push({
                code: ReclamationActionDetailCodes.DateEnlevement,
                type: ReclamationActionDetailType.Date,
                libelle: `Date d'enlèvement`,
                position: 2,
                valeurDate: newState.dateSouhaitee.toDateString()
            });
        }

        let adresseString = `${newState.adresseDestinationNom}\n${newState.adresseDestinationAdresse1}\n${newState.adresseDestinationAdresse2 ? newState.adresseDestinationAdresse2 + "\n" : ""}${newState.adresseDestinationCodePostal} ${newState.adresseDestinationVille}`;
        if (newState.adresseDestinationCode !== 3) {
            if (AdresseDestinations.find(x => x.id === newState.adresseDestinationCode) !== undefined) {
                adresseString = AdresseDestinations.find(x => x.id === newState.adresseDestinationCode).nom;
            }
        }
        actionData.details.push({
            code: ReclamationActionDetailCodes.AdresseDestination,
            type: ReclamationActionDetailType.Texte,
            libelle: `Adresse de destination`,
            position: actionData.details.length,
            valeurString: adresseString,
            valeurInteger: newState.adresseDestinationCode
        });

        actionData.details.push({
            code: ReclamationActionDetailCodes.MontantDevis,
            type: ReclamationActionDetailType.Flottant,
            libelle: 'Montant du devis',
            position: actionData.details.length,
            valeurFloat: newState.montantDevis
        });

        // Facture client
        if (newState.factureClient === '1') {
            actionData.details.push({
                code: ReclamationActionDetailCodes.NumeroFacture,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de facture',
                position: actionData.details.length,
                valeurString: newState.numeroFacture
            });
        }

        // Articles à enlever
        let articles = newState.articles.filter(x => x.quantiteAEnlever !== 0);
        if (articles.length === 0) {
            return null;
        }
        for (let i = 0; i < articles.length; i++) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.CodeArticleQuantite,
                type: ReclamationActionDetailType.CodeArticleQuantite,
                libelle: 'Code article à enlever avec quantité',
                position: actionData.details.length,
                valeurInteger: articles[i].quantiteAEnlever,
                valeurString: articles[i].codeArticle
            });
        }

        // Poids théorique
        actionData.details.push({
            code: ReclamationActionDetailCodes.Poids,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Poids théorique',
            position: actionData.details.length,
            valeurInteger: newState.poidsTheorique
        });

        // Nombre de colis
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombreColis,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de colis',
            position: actionData.details.length,
            valeurInteger: newState.nbColis
        });

        // Nombre de palettes
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombrePalettes,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de palettes',
            position: actionData.details.length,
            valeurInteger: newState.nbPalettes
        });

        // Nombre de longueurs
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombreLongueurs,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de longueurs',
            position: actionData.details.length,
            valeurInteger: newState.nbLongueurs
        });

        // TranporteurInitial
        actionData.details.push({
            code: ReclamationActionDetailCodes.TransporteurInitial,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Transporteur initial',
            position: actionData.details.length,
            valeurString: this.props.transporteurInitial ? this.props.transporteurInitial.nom + ' / ' + this.props.transporteurInitial.contrat : ''
        });

        return actionData;
    }

    handleChange = (event, codeArticle) => {

        let newState;
        if (codeArticle) {
            
            newState = {
                ...this.state,
                articles: this.state.articles.map(article => { let a = article.codeArticle !== codeArticle ? article : { ...article, quantiteAEnlever: Math.max(Number(event.target.value), 0) }; return a; })
            };

            newState.poidsTheorique = newState.articles.reduce((currentValue, nextValue) => currentValue + Number(nextValue.quantiteAEnlever) * nextValue.poids, 0);
        } else {
            newState = {
                ...this.state,
                [event.target.name]: event.target.value
            };

            if (event.target.name === "adresseDestinationCode") {
                newState = { ...this.state, [event.target.name]: parseInt(event.target.value, 10) };
            }
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }



    handleChangeInteger = (event) => {

        let newState;

        newState = {
            ...this.state,
            [event.target.name]: Math.max(event.target.value,0)
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    handleChangeArticleGestion = (suggestion) => {
        
        if (!suggestion) {
            return;
        }

        let newState;

        newState = {
            ...this.state,
            articleHorsPiece: { codeArticle: suggestion.reference, designationArticle: suggestion.designation, quantite: 0, poids: suggestion.poids, positionnement: suggestion.positionnement}
        };

        this.setState(newState);
    }

    handleAddArticle = () => {
        let newState;
        let newArticle = JSON.parse(JSON.stringify(this.state.articleHorsPiece));
        newArticle.quantiteAEnlever = 0;

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            articleHorsPiece: null
        };

        this.props.clearArticleGestionValue();

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData);
    }

    handleAddTR = () => {
        let newState;
        let newArticle = {
            codeArticle: this.state.codeTR,
            designationArticle: "N/A",
            poids: 0,
            positionnement: "N/A",
            quantite: 0,
            quantiteAEnlever: 0

        };

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            codeTR: ''
        };

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData);
    }


    render() {
        const { classes, transporteurInitial } = this.props;

        let addArticleDisabled = !this.state.articleHorsPiece || !this.state.articleHorsPiece.codeArticle || this.state.articleHorsPiece.codeArticle.length === 0;

        if (!addArticleDisabled) {
            addArticleDisabled = this.state.articles.find(x => x.codeArticle === this.state.articleHorsPiece.codeArticle) !== undefined;
        }

        return (
            <DialogContent>
                <div hidden>
                    <Typography variant="h6" gutterBottom>Effectuer cette action pour :</Typography>
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Envoyer un email d'information au service demandes d'enlèvements`}</Typography>
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Envoyer un email à l'émetteur du dossier après-vente`}</Typography>
                    <Typography variant="body2" gutterBottom className={classes.detailValue}> Envoyer un email / sms au client pour le prévenir du passage du transporteur</Typography>
                </div>

                <div className={classes.container}>
                    <div className={classes.column}>
                    
                        <Stack spacing={1} mt={1}>
                            <Typography variant="h6" gutterBottom>{`Adresse d'enlèvement :`}</Typography>
                            <TextField required name="adresseEnlevementNomLivraison" label="Nom" value={this.state.adresseEnlevementNomLivraison} onChange={e => this.handleChange(e)} fullWidth />
                            <TextField required name="adresseEnlevementAdresse1" label="Adresse" value={this.state.adresseEnlevementAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                            <TextField name="adresseEnlevementAdresse2" label="Complément" value={!this.state.adresseEnlevementAdresse2 ? '' : this.state.adresseEnlevementAdresse2} onChange={e => this.handleChange(e)} fullWidth />

                            <Grid container spacing={0}>
                                <Grid item xs={4} >
                                    <TextField sx={{ marginRight: '8px' }} required name="adresseEnlevementCodePostal" label="Code Postal" value={this.state.adresseEnlevementCodePostal} onChange={e => this.handleChange(e)} />

                                </Grid>
                                <Grid item xs={8}>
                                    <TextField required fullWidth name="adresseEnlevementVille" label="Ville" value={this.state.adresseEnlevementVille} onChange={e => this.handleChange(e)} />
                                </Grid>
                            </Grid>

                        </Stack>

                        <>
                            <Typography variant="h6" gutterBottom className={classes.marginTop}>Contact client nécessaire à l'enlèvement :</Typography>
                            <Stack spacing={1} mt={1}>
                                <TextField required name="contactClientNom" label="Nom" value={this.state.contactClientNom} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="contactClientEmail" label="Email" value={this.state.contactClientEmail} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="contactClientTelephone" label="Téléphone" value={this.state.contactClientTelephone} onChange={e => this.handleChange(e)} fullWidth />
                            </Stack>
                        </>
                    </div>

                    <div className={classes.column}>


                        <>

                            <Stack spacing={1} mt={1}>
                                <Typography variant="h6" gutterBottom>Adresse de destination :</Typography>
                                <TextField
                                    select
                                    required
                                    fullWidth
                                    name="adresseDestinationCode"
                                    label="Destination"
                                    value={this.state.adresseDestinationCode}
                                    onChange={e => this.handleChange(e)}
                                >
                                    {AdresseDestinations.map(adresse => (

                                        <MenuItem key={adresse.id} value={adresse.id}>{adresse.nom}</MenuItem>

                                    ))}
                                </TextField >


                                {this.state.adresseDestinationCode === 3 && (
                                    <>
                                        <TextField required name="adresseDestinationNom" label="Nom" value={this.state.adresseDestinationNom} onChange={e => this.handleChange(e)} fullWidth autoFocus />
                                        <TextField required name="adresseDestinationAdresse1" label="Adresse" value={this.state.adresseDestinationAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField          name="adresseDestinationAdresse2" label="Complément" value={this.state.adresseDestinationAdresse2} onChange={e => this.handleChange(e)} fullWidth />

                                        <Grid container spacing={0}>
                                            <Grid item xs={4} >
                                                <TextField sx={{ marginRight:'8px'}} required name="adresseDestinationCodePostal" label="Code Postal" value={this.state.adresseDestinationCodePostal} onChange={e => this.handleChange(e)} />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField required fullWidth name="adresseDestinationVille" label="Ville" value={this.state.adresseDestinationVille} onChange={e => this.handleChange(e)} />
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </Stack>
                        </>

                        <>
                            <Typography variant="h6" gutterBottom className={classes.marginTop}>Facture client :</Typography>

                            <TextField required name="montantDevis" label="Montant du devis transporteur" value={this.state.montantDevis} fullWidth onChange={e => this.handleChange(e)} />

                            <FormControl component="fieldset" className={classes.marginTop}>
                                <FormLabel component="legend">Facturé au client ?</FormLabel>
                                <RadioGroup required name="factureClient" className={classes.group} value={this.state.factureClient} onChange={e => this.handleChange(e)} row>
                                    <FormControlLabel value="1" control={<Radio />} label="Oui" />
                                    <FormControlLabel value="0" control={<Radio />} label="Non" />
                                </RadioGroup>
                            </FormControl>

                            {this.state.factureClient === '1' && (
                                <TextField required name="numeroFacture" label="Numéro de facture" fullWidth value={this.state.numeroFacture} onChange={e => this.handleChange(e)} />
                                )}
                        </>

                        {transporteurInitial && (
                            <>

                                <Typography variant="h6" gutterBottom className={classes.marginTop}>Transporteur initial :</Typography>

                                <Typography gutterBottom>{transporteurInitial.nom} / {transporteurInitial.contrat}</Typography>

                            </>
                        )}


                    </div>
                </div>

                <div>
                    <Typography variant="h6" className={classes.marginTop} gutterBottom>Article(s) à enlever :</Typography>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.cell}>Code article</TableCell>
                                <TableCell className={classes.cell}>Désignation</TableCell>
                                <TableCell className={classes.cell}>Quantité<br/>commandé</TableCell>
                                <TableCell className={classes.cell}>Quantité à enlever</TableCell>
                                <TableCell className={classes.cell}>Poids unitaire</TableCell>
                                <TableCell className={classes.cell}>Positionnement</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.articles.map(x => (
                                <TableRow key={x.codeArticle}>
                                    <TableCell className={classes.cell}>{x.codeArticle}</TableCell>
                                    <TableCell className={classes.cell}>{x.designationArticle}</TableCell>
                                    <TableCell className={classes.cell}>{x.quantite}</TableCell>
                                    <TableCell className={classes.cell}><TextField type="number" value={x.quantiteAEnlever} onChange={e => this.handleChange(e, x.codeArticle)} /></TableCell>
                                    <TableCell className={classes.cell}>{x.poids} g</TableCell>
                                    <TableCell className={classes.cell}>{x.positionnement}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                    <Stack direction="row" mt={1} spacing={1} justifyContent="space-between">
                        <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">
                            <ArticleGestionSearch namespace="addAction" onChange={this.handleChangeArticleGestion} isRequired={false} label="Article hors pièce" infosLogistique />

                            <Button onClick={this.handleAddArticle} disabled={addArticleDisabled}>Ajouter</Button>
                        </Stack>
                        <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">

                            <TextField name="codeTR" label="Code TR" value={this.state.codeTR} onChange={e => this.handleChange(e)} fullWidth />

                            <Button onClick={this.handleAddTR} disabled={this.state.codeTR === ''}>Ajouter TR</Button>
                        </Stack>
                    </Stack>

                    <div>
                        <Typography variant="h6" gutterBottom>Expédition :</Typography>

                        <MyDatePicker
                            label="Date d'enlèvement souhaitée"
                            value={this.state.dateSouhaitee}
                            onChange={value => this.handleChange({ target: { name: 'dateSouhaitee', value: value } })}
                            disableFuture={false}
                            disablePast={true}
                            disableSunday={true}
                            fullWidth
                        />

                        <TextField required name="poidsTheorique" label="Poids théorique (en g)" value={this.state.poidsTheorique} onChange={this.handleChangeInteger} className={classes.marginTop} fullWidth />
                        <div className={classes.container}>
                            <TextField className={classes.marginTop} name="nbPalettes" label="Nombre de palettes" type="number" value={this.state.nbPalettes} onChange={this.handleChangeInteger} />
                            <TextField className={classes.marginTop} name="nbColis" label="Nombre de colis" type="number" value={this.state.nbColis} onChange={this.handleChangeInteger} />
                            <TextField className={classes.marginTop} name="nbLongueurs" label="Nombre de longueurs" type="number" value={this.state.nbLongueurs} onChange={this.handleChangeInteger} />
                        </div>
                    </div>
                </div>
            </DialogContent >
        );
    }
}

DemandeEnlevementDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    articles: PropTypes.array.isRequired,
    adresse: PropTypes.object
};

export default withStyles(styles)(DemandeEnlevementDialogContent);